/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_TOP_EMPLOYEE_SPENDING_INSIGHTS_GQL,
  GET_TOP_MERCHANT_SPENDING_INSIGHTS_GQL,
  GET_TOP_CATEGORY_SPENDING_INSIGHTS_GQL,
} from '@/graphql/sentinelInsights.gql';

export default {
  namespaced: true,
  state: {
    topEmployeeSpendingInsightData: null,
    topMerchantSpendingInsightData: null,
    topCategorySpendingInsightData: null,
  },
  mutations: {
    GET_TOP_EMPLOYEE_SPENDING_INSIGHTS(state, payload) {
      state.topEmployeeSpendingInsightData = payload;
    },
    GET_TOP_MERCHANT_SPENDING_INSIGHTS(state, payload) {
      state.topMerchantSpendingInsightData = payload;
    },
    GET_TOP_CATEGORY_SPENDING_INSIGHTS(state, payload) {
      state.topCategorySpendingInsightData = payload;
    },
  },
  actions: {
    async getTopEmployeeSpendingInsightData({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_TOP_EMPLOYEE_SPENDING_INSIGHTS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {

          commit('GET_TOP_EMPLOYEE_SPENDING_INSIGHTS', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getTopMerchantSpendingInsightData({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_TOP_MERCHANT_SPENDING_INSIGHTS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {

          commit('GET_TOP_MERCHANT_SPENDING_INSIGHTS', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getTopCategorySpendingInsightData({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_TOP_CATEGORY_SPENDING_INSIGHTS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {

          commit('GET_TOP_CATEGORY_SPENDING_INSIGHTS', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
  },
  getters: {
    topEmployeeSpendingInsightData: state => state.topEmployeeSpendingInsightData,
    topMerchantSpendingInsightData: state => state.topMerchantSpendingInsightData,
    topCategorySpendingInsightData: state => state.topCategorySpendingInsightData,
  },
};
